import { Assignment } from "@mui/icons-material";
import {GetSeferData} from "SeferPetach/GetData";

export async function getUserList(data) {
    const args = data;
    var payload = await GetSeferData("glusr", args);
    return (payload);
}
export async function getUserByID(user_data){
    const args = {
        UserId: user_data.UserId,
    };
    var payload = await GetSeferData("gusr", args);
    return (payload);
}
export async function updateUser(obj) {
    const args = {
        UserId                  :   obj.UserId,
        Email                   :   obj.Email,
        FirstName               :   obj.FirstName,
        LastName                :   obj.LastName,
        ModuleName              :   obj.ModuleName,
        DepartmentId            :   obj.DepartmentId,
        AssignmentId            :   obj.AssignmentId,
        StatusId                :   obj.StatusId,
        History                 :   obj.History,
        Mentor                  :   obj.Mentor,
        HiredDate               :   obj.HiredDate,
    };
    var payload = await GetSeferData("uusr", args);
    return (payload);
}
export async function updateUserStatus(obj) {
    const args = {
        UserId                  :   obj.UserId,
        StatusId                :   obj.StatusId,
    };
    var payload = await GetSeferData("uusrst", args);
    return (payload);
}
export async function deleteUser(obj){
    const args = {
        UserId: obj.UserId
    };
    var payload = await GetSeferData("dusr", args);
    return (payload);
}

export async function getDepartmentList(obj) {
    const args = obj;
    var payload = await GetSeferData("gldepartment", args);
    return (payload);
}
export async function getDepartmentByID(data){
    const args = {
        DepartmentId: data.DepartmentId,
    };
    var payload = await GetSeferData("gdepartment", args);
    return (payload);
}
export async function updateDepartment(obj) {
    let args = {
        DepartmentId    : obj.DepartmentId,
        DepartmentName  : obj.DepartmentName,
        StatusId        : obj.StatusId,
        Inserted        : [],
        Removed         : [],
    };

    let i = 0;
    for (i = 0; i < obj.Current.length; i++) {
        let contains = obj.Old.some((d) => d.AssignmentId === obj.Current[i].AssignmentId);
        if (!contains) {
            args.Inserted.push({
                DepartmentId : obj.DepartmentId,
                AssignmentId : obj.Current[i].AssignmentId,
            });
        }
    }

    for (i = 0; i < obj.Old.length; i++) {
        let contains = obj.Current.some((d) => d.AssignmentId === obj.Old[i].AssignmentId);
        if (!contains) {
            args.Removed.push({
                DepartmentId : obj.DepartmentId,
                AssignmentId : obj.Old[i].AssignmentId,
            });
        }
    }

    var payload = await GetSeferData("udepartment", args);
    return payload;
}
export async function updateDepartmentStatus(obj) {
    const args = {
        DepartmentId            :   obj.DepartmentId,
        StatusId                :   obj.StatusId,
    };
    var payload = await GetSeferData("udepartmentst", args);
    return (payload);
}
export async function deleteDepartment(obj){
    const args = {
        DepartmentId: obj.DepartmentId
    };
    var payload = await GetSeferData("ddepartment", args);
    return (payload);
}

export async function getAssignmentList(obj) {
    const args = obj;
    var payload = await GetSeferData("glassignment", args);
    return (payload);
}
export async function getAssignmentByID(data){
    const args = {
        AssignmentId: data.AssignmentId,
    };
    var payload = await GetSeferData("gassignment", args);
    return (payload);
}
export async function updateAssignment(obj) {
    const args = {
        AssignmentId            :   obj.AssignmentId,
        AssignmentNamePt        :   obj.AssignmentNamePt,
        AssignmentNameEn        :   obj.AssignmentNameEn,
        AssignmentNameEs        :   obj.AssignmentNameEs,        
        StatusId                :   obj.StatusId,
    };
    var payload = await GetSeferData("uassignment", args);
    return (payload);
}
export async function updateAssignmentStatus(obj) {
    const args = {
        AssignmentId            :   obj.AssignmentId,
        StatusId                :   obj.StatusId,
    };
    var payload = await GetSeferData("uassignmentst", args);
    return (payload);
}
export async function deleteAssignment(obj){
    const args = {
        AssignmentId: obj.AssignmentId
    };
    var payload = await GetSeferData("dassignment", args);
    return (payload);
}


export async function getDepartmentAssignmentList(obj) {
    const args = obj;
    var payload = await GetSeferData("gldepartmentassignment", args);
    return (payload);
}